import React from 'react';
import PropTypes from 'prop-types';
import OneColumnLayout from '../OneColumnLayout';
import './MultipleColumnLayout.scss';

const MultipleColumnLayout = ({
  columnPositionClassMap,
  items,
  analysisId,
  projectId,
  containerClass,
  isLoading,
  hasError,
}) => {
  return (
    <div data-testid="section-areas-container" className={containerClass}>
      {Object.keys(columnPositionClassMap).map((key) => {
        return (
          <div
            className={`panel-area panel-area-${columnPositionClassMap[key]}`}
            key={`panel-area-${columnPositionClassMap[key]}`}
            data-testid={`panel-area-${columnPositionClassMap[key]}`}
          >
            <OneColumnLayout
              analysisId={analysisId}
              projectId={projectId}
              isLoading={isLoading}
              hasError={hasError}
              items={items.filter(
                (i) => i.analysisColumn === columnPositionClassMap[key]
              )}
              isInMultipleColumnLayout
            />
          </div>
        );
      })}
    </div>
  );
};

MultipleColumnLayout.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  columnPositionClassMap: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
  analysisId: PropTypes.number.isRequired,
  projectId: PropTypes.string.isRequired,
  containerClass: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default MultipleColumnLayout;
